import React, {useContext} from 'react';
import * as PropTypes from 'prop-types';
import styles from './styles.modules.scss';
import Popover from 'ati-ui-react/components/Tip/Popover';
import Preloader from 'ati-ui-react/components/Preloader';
import {DataContext} from 'contexts';

const LoadingPopover = ({children, visible, onVisibilityChange}) => {
    const {isMobile} =  useContext(DataContext);

    return (
        <Popover
            isClosedOnOutsideClick
            restorePosition
            fixedBodyPosition={isMobile}
            isCenterAlignmentOnAdaptive={false}
            mainContent={(
                <div
                    className={styles['preloader']}
                >
                    <Preloader/>
                </div>

            )}
            mainContentClassName={styles['content-section']}
            placement="top"
            templateWrapperClassName={styles['popover-container']}
            visible={visible}

            onCloseClick={(event)=>onVisibilityChange(false, event)}
            onVisibilityChange={onVisibilityChange}
        >
            <div
                onClick={() => {
                    onVisibilityChange(true);
                }}
            >
                {children}
            </div>
        </Popover>

    );
};

export default LoadingPopover;

LoadingPopover.propTypes = {
    children: PropTypes.node,
    visible: PropTypes.bool,
    onVisibilityChange: PropTypes.func
};
